<template>
    <div>
        <button class="btn btn-large editDialogButton" @click.prevent="openWindow()">Edit</button>
        <b-modal ref="query-modal" class="in" @shown="afterOpen" @ok="handleOK" :no-close-on-backdrop="true">
            <template v-slot:modal-header>
                <h3>Custom variables</h3>
            </template>
            <ActionList v-model="actionsToModify"/>
        </b-modal>
    </div>
</template>

<script>
import ActionList from "./ActionList";
import {queryToString} from "../queryBuilderAdapter";

export default {
	props: ["actions"],
	components: {ActionList},
	data: () => ({
		actionsToModify: []
	}),
	methods: {
		openWindow() {
			let modal = this.$refs["query-modal"];
			this.actionsToModify = JSON.parse(JSON.stringify(this.actions));
			modal.show();
		},
		afterOpen(event) {
			event.vueTarget.$refs.modal.classList.add("in");
		},
		handleOK() {
			this.$emit("change", this.actionsToModify);
		}
	},
	computed: {
		asString() {
			return queryToString(this.value);
		}
	},
	watch: {
		actions(newVal) {
			this.actionsToModify = JSON.parse(JSON.stringify(newVal));
		}
	}
};
</script>

<style lang="scss" scoped>
.editDialogButton:hover {
    white-space: normal;
}
/deep/ {
    .pnl {
        border: 1px solid #c5c5c5; border-radius: 5px;
        border-left-width: 2px;
    }

    .pnl-row {
        margin: 5px 0 5px 0; padding: 10px 15px;
        background-color: #f5f5f5;
        border-radius: 5px;
        border-bottom:1px solid #cecece;
    }

    .pnl-hdr {
        background-color: #f5f5f5; border-color: #ddd; padding: 10px 15px; border-top-left-radius: 3px; border-top-right-radius: 3px;
    }

    .pnl-list {
        margin: 15px 5px 15px 15px; padding: 10px 15px;
        border: 1px solid rgba(0,0,0,.125);
        border-left: 2px solid #8bc34a;
    }
}
</style>
